module.exports = __webpack_public_path__ + "img/Ulrikas_E-learning_info_om_kurs2.28826b1d.jpg";